// extracted by mini-css-extract-plugin
module.exports = {"root":"LandingPageFlex_root__19s6b"};